import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';

import UploadFileContainer, { UploadFileContainerProps } from './UploadFile.container';

interface Props extends UploadFileContainerProps {
  onSetVisible: (value: boolean) => void;
}

const UploadFilePopupContainer: React.FC<Props> = ({ onSetVisible, ...props }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible
      onSetVisible={onSetVisible}
      testId="upload-file"
    >
      <Text
        data-testid="upload-file-modal_title"
        size="2xl"
        weight={700}
        textAlign="center"
      >
        {t('How Do You Want to Upload?')}
      </Text>
      
      <Box margin={{ top: 'spacing24' }}>
        <UploadFileContainer {...props} />
      </Box>
    </Modal>
  );
};

export default UploadFilePopupContainer;
